import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPlanwiseReport } from "../slice/GroupDataSlice";
import { fetchCustomers } from "../slice/CustomerSlice";
import { Row, Col, Table, Badge, Button, Accordion } from "react-bootstrap";
import { DropDown } from "../components/Forms";
import { exportPlanwisePDF, exportPlanwiseExcel } from "../pdf/PlanwiseExport";
import { Buttons } from "../components/Buttons";
import Pagination from "../components/Pagination"; 

const DashboardPlanwiseReport = () => {
  const dispatch = useDispatch();
  const [selectedPlan, setSelectedPlan] = useState("");
  const { plans } = useSelector((state) => state.customers);
  const { planwiseReportData, status } = useSelector(
    (state) => state.groupData
  );
  const [tempPlan, setTempPlan] = useState("");

  // --- Pagination State ---
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of customers per table page

  useEffect(() => {
    dispatch(fetchCustomers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchPlanwiseReport({ plan_id: selectedPlan }));
  }, [dispatch, selectedPlan]);

  const handleReset = () => {
    setTempPlan("");
    setSelectedPlan("");
    dispatch(fetchPlanwiseReport({ plan_id: "" }));
    setCurrentPage(1);
  };

  const handleApplyFilter = () => {
    setSelectedPlan(tempPlan);
    setCurrentPage(1);
  };

  return (
    <Row className="py-3">
      <Col xs="12">
        <h2 className="fw-bold mb-4">Plan-wise Report</h2>

        {/* Filter Controls */}
        <Row className="align-items-end mb-4">
          <Col xs={12} md="auto" className="mb-3 mb-md-0" style={{ minWidth: "250px" }}>
            <DropDown
              textlabel="Select Plan"
              value={tempPlan}
              onChange={(e) => setTempPlan(e.target.value)}
              options={[
                { value: "", label: "All Plans" },
                ...(plans || []).map((p) => ({
                  value: p.plan_id,
                  label: p.plan_name,
                })),
              ]}
            />
          </Col>

          <Col xs={12} md="auto">
            <div className="d-flex gap-2 flex-wrap">
              <Button
                variant="success"
                className="px-4"
                onClick={handleApplyFilter}
              >
                Apply Filter
              </Button>
              <Button variant="outline-dark" onClick={handleReset}>
                Reset Filter
              </Button>
              <Buttons btnlabel="Export PDF" className="add-btn" onClick={() => exportPlanwisePDF(planwiseReportData)} />
              <Buttons btnlabel="Export Excel" className="add-btn" onClick={() => exportPlanwiseExcel(planwiseReportData)} />
            </div>
          </Col>
        </Row>

        {status === "loading" ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
            <div className="mt-2">Loading Report...</div>
          </div>
        ) : (
          <Accordion alwaysOpen>
            {planwiseReportData.map((planGroup, idx) => {
              // --- Calculate Pagination for THIS specific plan ---
              const indexOfLastItem = currentPage * itemsPerPage;
              const indexOfFirstItem = indexOfLastItem - itemsPerPage;
              const currentCustomers = planGroup.data?.slice(indexOfFirstItem, indexOfLastItem) || [];
              const totalPages = Math.ceil((planGroup.data?.length || 0) / itemsPerPage);

              return (
                <Accordion.Item eventKey={idx.toString()} key={idx} className="mb-3 border shadow-sm">
                  <Accordion.Header>
                    <div className="d-flex justify-content-between align-items-center w-100 me-3">
                      <span className="fw-bold fs-5">{planGroup.plan_name} Plan</span>
                      <div className="d-flex gap-1">
                        <Badge bg="info" className="px-3 py-2">Total Customers: {planGroup.total_boxes}</Badge>
                        <Badge bg="danger" className="px-2 py-2">Pending: ₹{planGroup.data?.reduce((sum, item) => sum + Number(item.total_pending_amount || 0), 0).toLocaleString()}</Badge>
                        <Badge bg="success" className="px-2 py-2">Paid: ₹{planGroup.data?.reduce((sum, item) => sum + Number(item.total_collection_amount || 0), 0).toLocaleString()}</Badge>

                      </div>
                    </div>
                  </Accordion.Header>
                  
                  <Accordion.Body className="p-0">
                    <Table striped bordered hover responsive className="mb-0">
                      <thead className="table-dark">
                        <tr>
                          <th>S.No</th>
                          <th>Customer No</th>
                          <th>Customer Name</th>
                          <th>Area</th>
                          <th>Plan Prize</th>
                          <th>Staff Name</th>
                          <th>Total Collection</th>
                          <th>Pending Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentCustomers.length > 0 ? (
                          currentCustomers.map((customer, index) => (
                            <tr key={customer.customer_id}>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td>{customer.customer_no}</td>
                              <td>{customer.name}</td>
                              <td>{customer.area_name}</td>
                              <td>{customer.plan_prize}</td>
                              <td>{customer.staff_name}</td>
                              {/* <td>₹{customer.total_collection_amount}</td> */}
                              <td> {Number(customer.total_collection_amount) > 0  ? `₹${customer.total_collection_amount}`  : "-"} </td>
       
                              <td className="fw-bold text-danger">₹{customer.total_pending_amount}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center py-4 text-muted">No customers found</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    
                    {/* Pagination control inside the Accordion Body */}
                    <div className="p-3 d-flex justify-content-end">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        )}
      </Col>
    </Row>
  );
};

export default DashboardPlanwiseReport;